// Carries the authorization URL even though the applicative function has already navigated to it: a
// dispatched applicative function always returns an Action, never `Promise<void>`, and this is the
// only data the flow produced.
export type SsoAuthenticationStartedPayload = {
	readonly authorizationUrl: string;
};

export type SsoAuthenticationStartedAction = {
	type: 'SSO_AUTHENTICATION_STARTED';
	payload: SsoAuthenticationStartedPayload;
};

export default (payload: SsoAuthenticationStartedPayload): SsoAuthenticationStartedAction => ({
	type: 'SSO_AUTHENTICATION_STARTED',
	payload,
});
